"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = require("./styled");

var _getTransform = _interopRequireDefault(require("./helpers/getTransform"));

var ZoomedImage = function ZoomedImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      close = _ref.close,
      originalRect = _ref.originalRect;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isCentered = _useState2[0],
      setIsCentered = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsCentered(true);
  }, []);

  var handleClick = function handleClick() {
    setIsCentered(false);
    setTimeout(close, 300);
  };

  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_styled.StyledImageContainer, {
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledBackdrop, {
    isCentered: isCentered
  }), /*#__PURE__*/_react["default"].createElement(_styled.StyledCenteredImage, {
    src: src,
    alt: alt,
    top: originalRect.top,
    left: originalRect.left,
    width: originalRect.width,
    height: originalRect.height,
    isCentered: isCentered,
    transform: (0, _getTransform["default"])(originalRect)
  })), document.body);
};

ZoomedImage.propTypes = {
  src: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  close: _propTypes["default"].func,
  originalRect: _propTypes["default"].object
};
ZoomedImage.defaultProps = {
  src: '',
  alt: '',
  close: function close() {},
  originalRect: {}
};
var _default = ZoomedImage;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/ZoomableImage/zoomedImage.js
// module id = ziPY
// module chunks = 0